import { Inject, Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ObjectActions from './device-last-message.actions';
import * as AppActions from '../app/actions';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GeneralApiResponseInterface } from '../../layout/main/main.model';
import { DeviceLastMessageInterface } from './device-last-message.model';
import { IotDeviceManagementPortalAppState } from '../iotDeviceManagementPortalApp.reducer';
import { Store } from '@ngrx/store';
import { PageFiltersAndSettingsService } from '../../shared/service/page-filters-and-settings/page-filters-and-settings.service';

@Injectable()
export class DeviceLastMessageEffects {
  constructor(
    private actions$: Actions<ObjectActions.DeviceLastMessageActions>,
    private http: HttpClient,
    private readonly store: Store<IotDeviceManagementPortalAppState>,
    private readonly pageFiltersAndSettings: PageFiltersAndSettingsService,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  private DEVICES_URLS = {
    GET: {
      DEVICE_LAST_MESSAGE: '/device-last-message',
    },
  };

  @Effect()
  getDeviceLastMessages$ = this.actions$.pipe(
    ofType(ObjectActions.DeviceActionTypes.GetDeviceLastMessages),
    switchMap((objectData: ObjectActions.GetDeviceLastMessages) => {
      this.store.dispatch(new AppActions.ShowLoader());
      const url = `${this.baseUrl}${this.DEVICES_URLS.GET.DEVICE_LAST_MESSAGE}`;
      let params: HttpParams = new HttpParams();

      params = params
        .append('page', String(objectData.query.page))
        .append('limit', String(objectData.query.pageSize || 1000));

      if (objectData.query.order) {
        params = params
          .set('order', `${objectData.query.order}`)
          .set('orderType', `${objectData.query.orderType.toUpperCase()}`);
      }

      if (objectData.query.search !== undefined) {
        params = params.set('searchType', String('deviceLastMessageSearch'));
        params = params.set('search', String(objectData.query.search));
      }

      if (objectData.query.startDate) {
        params = params.set('startDate', `${objectData.query.startDate}`).set('endDate', `${objectData.query.endDate}`);
      }

      return this.http
        .get<GeneralApiResponseInterface<DeviceLastMessageInterface[]>>(url, {
          params,
        })
        .pipe(
          switchMap((response: GeneralApiResponseInterface<DeviceLastMessageInterface[]>) => {
            return of(new ObjectActions.GetDeviceLastMessagesCompleted(response['data'], response['total']), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
    }),
  );

}
